import axiosInstance from "../../Middleware/AxiosInstanceInterceptor";

const BASE_URL = "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com";

/* ---------------- PAYMENTS ---------------- */

export const getPayments = async (token, paymentStatus) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/dashboard/getAllPayments`,
    {
      params: {
        page: 1,
        ...(paymentStatus && { state: paymentStatus }),
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "module-id": "dashboard",
      },
    }
  );

  return res.data.response;
};

/* ---------------- ARBITRATION ---------------- */

export const getArbitrationStats = async (token) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/dashboard/getAllArbitrations`,
    { 
        params: {
        page: 1,
      },
      
      headers: { 
        Authorization: `Bearer ${token}`,
       "module-id": "dashboard",
     },
    }
  );

   return res.data.response;;
};

/* ---------------- EFILING ---------------- */

export const getEfilingStats = async (token) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/dashboard/getAllEfilings`,
    {
      params: {
        page: 1,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        "module-id": "dashboard",
      },
    }
  );

  return res.data;
};

/* ---------------- CUSTOMERS ---------------- */

export const getCustomerStats = async (token) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/dashboard/getAll`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "module-id": "dashboard",
      },
    }
  );

  return res.data;
};